import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { IAppSettings } from '@app/shared-module/models';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';
import { AppLanguage } from '@core';

registerLocaleData(localeFr, AppLanguage.Fr);
registerLocaleData(localeEn, AppLanguage.En);

async function initialize() {
    if (environment.production) {
        enableProdMode();
    }

    const appModuleContainer = await import('./app/app.module');
    platformBrowserDynamic()
        .bootstrapModule(appModuleContainer.AppModule, {
            providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]
        })
        .catch((err) => console.error(err));
}
async function loadAppSettings() {
	try {
		const response = await fetch('/assets/configs/app-settings.json?v=' + environment.appVersion);
		if (!response.ok) {
			throw new Error(`Failed to load settings: ${response.statusText}`);
		}

		const settings: IAppSettings = await response.json();
		Object.assign(environment, settings);
		if (settings.withLocalSettings) {
			const localResponse = await fetch('/assets/configs/app-settings.local.json');
			if (localResponse.ok) {
				const localSettings: IAppSettings = await localResponse.json();
				Object.assign(environment, localSettings);				
			}
		}

	} catch (err) {
		console.error('Error loading app settings:', err);
	} finally {
		initialize();
	}
}
loadAppSettings();
